import {useAppState} from 'store/utils';

export function useBudgetStore(): BudgetState {
  return useAppState().budget;
}
